import React from "react";
import { Link } from "react-router-dom";
import useSEO from "../seo/useSEO";
import "../index.css";

export default function NotFound() {
  useSEO({
    title: "Page introuvable | HLBK",
    description: "Cette page n’existe pas ou n’est plus disponible.",
    noindex: true,
  });

  return (
    <section className="not-found">
      <div className="not-found-content">

        <p className="not-found-code">404</p>

        <h1>Cette page n’existe plus.</h1>

        <p>
          La page que vous recherchez a peut-être été déplacée
          ou supprimée.
        </p>

        <Link to="/" className="btn-cta btn-cta-red">
          RETOUR À L’ACCUEIL
        </Link>

      </div>
    </section>
  );
}